/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";
import EmployeeTraining from "./EmployeeTraining";
import { api } from "api";

class EmployeeTrainings extends Component {
    state = {
        filteredTrainingsData: [],
        filterTerm: "",
        error: null,
        activePage: 1,
        dataFetched: false,
        sort_by: "trTraining",
        sort_dir: "desc",
        searchedData: []
    };

    languageCode = Helpers.getLangCode(localStorage.getItem("i18nextLng"));

    settings = {
        itemsPerPage: 10,
    };
    fetchTrainings = () => {
        this.props.onProcessBegin();
        api.get(`api/employee-training-management/get?employeeId=${this.props.selectedFilters.selectedEmployee}
                                                    &isJoined=${this.props.selectedFilters.selectedJoined}
                                                    &isSuccess=${this.props.selectedFilters.selectedSuccess}
                                                    &trainingMethod=${this.props.selectedFilters.selectedTrainingMethod}
                                                    &trainingArea=${this.props.selectedFilters.selectedTrainingArea}
                                                    &positionTrainingTypes=${JSON.stringify(this.props.selectedFilters.selectedPositionTrainingTypes)}
                                                    &technicalPositionPromotionTypes=${JSON.stringify(this.props.selectedFilters.selectedTechnicalPositionTrainingTypes)}`)
            .then((response) => {
                this.setState({
                    filteredTrainingsData: response.data.data.employeeTrainings,
                    searchedData: response.data.data.employeeTrainings
                });
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.props.onProcessEnd();
            });
    }
    componentDidMount = () => this.fetchTrainings();

    componentDidUpdate(prevProps, prevState) {
        if (this.state.filterTerm !== prevState.filterTerm) {
            this.setState({
                filteredTrainingsData: this.state.searchedData.filter(
                    (item) => {
                        return (Helpers.getTurkishCharaterFixedList(item.training.name).includes(Helpers.getTurkishCharaterFixedList(this.state.filterTerm)));
                    }
                ),
            });
        }
        if (prevProps.selectedFilters !== this.props.selectedFilters) {
            this.fetchTrainings();
        }
    }

    handlePageChange = (pageNum) => {
        this.setState({ activePage: pageNum });
    };

    handleFilter = (e) => {
        this.setState({ filterTerm: e.target.value });
    };

    handleExport = () => {
        return async () => {
            this.onBegin();
            await api.get(`api/employee-training-management/export-employee-trainings?employeeId=${this.props.selectedFilters.selectedEmployee}
                            &isJoined=${this.props.selectedFilters.selectedJoined}
                            &isSuccess=${this.props.selectedFilters.selectedSuccess}
                            &trainingMethod=${this.props.selectedFilters.selectedTrainingMethod}
                            &trainingArea=${this.props.selectedFilters.selectedTrainingArea}
                            &positionTrainingTypes=${JSON.stringify(this.props.selectedFilters.selectedPositionTrainingTypes)}
                            &technicalPositionPromotionTypes=${JSON.stringify(this.props.selectedFilters.selectedTechnicalPositionTrainingTypes)}`, { responseType: 'blob' })
                .then((res) => {
                    const fileName = res.headers["content-disposition"].split(';')[1].split('=')[1];
                    this.onExportSuccess(res, fileName);
                })
                .catch((e) => {
                    this.onError(e);
                });
        };
    };

    onBegin = () => {
        this.props.onProcessBegin();
    };

    onError = (err) => {
        console.error(err);
        this.props.onProcessEnd();
    };

    onExportSuccess = (res, fname) => {
        this.props.onProcessEnd();
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        link.click();
    };

    renderSearchBar = () => {
        return (
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
                <div className="inner-addon right-addon">
                    <span className="iconmford fo-icon-search"></span>
                    <input
                        type="text"
                        name="tableSearch"
                        id="tableSearch"
                        className="form-control"
                        placeholder={i18next.t("10053")}
                        onChange={(e) => this.handleFilter(e)}
                        value={this.state.filterTerm}
                    />
                </div>
            </div>
        );
    };

    renderHeaderToolbar = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginRight: "20px"
                }}
            >
                {this.renderSearchBar()}

                <Pagination
                    hideFirstLastPages={true}
                    prevPageText={i18next.t(10110)}
                    nextPageText={i18next.t(10111)}
                    hideDisabled={true}
                    hideNavigation={true}
                    activePage={this.state.activePage}
                    itemsCountPerPage={this.settings.itemsPerPage}
                    totalItemsCount={
                        this.state.filteredTrainingsData?.length > 0
                            ? this.state.filteredTrainingsData.length
                            : 0
                    }
                    onChange={(e) => this.handlePageChange(e)}
                    itemClass="page-item"
                    linkClass="page-link"
                />
            </div>
        );
    };

    renderFooterToolbar = () => {
        if (this.state.filteredTrainingsData.length > 0) {
            return (
                <div className="table-footer-toolbar">
                    <button className="export-button" onClick={this.handleExport()}>
                        <Trans desc="Dışa Aktar">10113</Trans>
                    </button>
                </div>
            );
        }
    };

    trTraining = "";
    trIsJoined = "";
    trIsSuccess = "";
    trTrainingMethod = "";
    trDuration = "";
    trIsTrainingRegistered = "";
    trTrainingArea = "";
    trWeight = "";
    trFutureWeight = "";
    trPositionTrainingType = "";
    trTechnicalPositionPromotionTrainingType = "";

    reOrder = (orderBy) => {
        let sort_dir = "asc";
        if (this.state.sort_dir === "asc") sort_dir = "desc";
        this.setState({
            sort_by: orderBy,
            sort_dir: sort_dir,
        });
    };

    setSortingClassNames = () => {
        this.trTraining = "";
        this.trIsJoined = "";
        this.trIsSuccess = "";
        this.trTrainingMethod = "";
        this.trDuration = "";
        this.trIsTrainingRegistered = "";
        this.trTrainingArea = "";
        this.trWeight = "";
        this.trFutureWeight = "";
        this.trPositionTrainingType = "";
        this.trTechnicalPositionPromotionTrainingType = "";

        switch (this.state.sort_by) {
            case "trTraining":
                this.trTraining = `_${this.state.sort_dir}`;
                break;
            case "trIsJoined":
                this.trIsJoined = `_${this.state.sort_dir}`;
                break;
            case "trIsSuccess":
                this.trIsSuccess = `_${this.state.sort_dir}`;
                break;
            case "trTrainingMethod":
                this.trTrainingMethod = `_${this.state.sort_dir}`;
                break;
            case "trDuration":
                this.trDuration = `_${this.state.sort_dir}`;
                break;
            case "trIsTrainingRegistered":
                this.trIsTrainingRegistered = `_${this.state.sort_dir}`;
                break;
            case "trTrainingArea":
                this.trTrainingArea = `_${this.state.sort_dir}`;
                break;
            case "trPositionTrainingType":
                this.trPositionTrainingType = `_${this.state.sort_dir}`;
                break;
            case "trTechnicalPositionPromotionTrainingType":
                this.trTechnicalPositionPromotionTrainingType = `_${this.state.sort_dir}`;
                break;
            case "trWeight":
                this.trWeight = `_${this.state.sort_dir}`;
                break;
            case "trFutureWeight":
                this.trFutureWeight = `_${this.state.sort_dir}`;
                break;
            default:
                this.trTraining = `_${this.state.sort_dir}`;
                break;
        }
    };

    renderData = (start, end) => {
        const sorted = this.state.filteredTrainingsData.sort((a, b) => {
            switch (this.state.sort_by) {
                case "trTrainingMethod":
                    return this.state.sort_dir === "desc"
                        ? a.trainingMethod?.label.localeCompare(b.trainingMethod?.label)
                        : b.trainingMethod?.label.localeCompare(a.trainingMethod?.label);
                case "trTraining":
                    return this.state.sort_dir === "desc"
                        ? a.training?.name.localeCompare(b.training?.name)
                        : b.training?.name.localeCompare(a.training?.name);
                case "trIsJoined":
                    return this.state.sort_dir === "desc"
                        ? a.isJoined.toString().localeCompare(b.isJoined.toString())
                        : b.isJoined.toString().localeCompare(a.isJoined.toString())
                case "trIsSuccess":
                    return this.state.sort_dir === "desc"
                        ? a.isSuccess.toString().localeCompare(b.isSuccess.toString())
                        : b.isSuccess.toString().localeCompare(a.isSuccess.toString())
                case "trDuration":
                    return this.state.sort_dir === "desc"
                        ? (b.duration ?? 0) - (a.duration ?? 0)
                        : (a.duration ?? 0) - (b.duration ?? 0);
                case "trIsTrainingRegistered":
                    return this.state.sort_dir === "desc"
                        ? a.isTrainingRegistered.toString().localeCompare(b.isTrainingRegistered.toString())
                        : b.isTrainingRegistered.toString().localeCompare(a.isTrainingRegistered.toString())
                case "trTrainingArea":
                    return this.state.sort_dir === "desc"
                        ? a.trainingArea[this.languageCode].localeCompare(b.trainingArea[this.languageCode])
                        : b.trainingArea[this.languageCode].localeCompare(a.trainingArea[this.languageCode]);
                case "trPositionTrainingType":
                    return this.state.sort_dir === "desc"
                        ? a.positionTrainingTypes[this.languageCode].toString().localeCompare(b.positionTrainingTypes[this.languageCode].toString())
                        : b.positionTrainingTypes[this.languageCode].toString().localeCompare(a.positionTrainingTypes[this.languageCode].toString())
                case "trTechnicalPositionPromotionTrainingType":
                    return this.state.sort_dir === "desc"
                        ? a.technicalPositionPromotion?.label.localeCompare(b.technicalPositionPromotion?.label)
                        : b.technicalPositionPromotion?.label.localeCompare(a.technicalPositionPromotion?.label);
                case "trWeight":
                    return this.state.sort_dir === "desc"
                        ? (b.weight ?? 0) - (a.weight ?? 0)
                        : (a.weight ?? 0) - (b.weight ?? 0);
                case "trFutureWeight":
                    return this.state.sort_dir === "desc"
                        ? (b.futureWeight ?? 0) - (a.futureWeight ?? 0)
                        : (a.futureWeight ?? 0) - (b.futureWeight ?? 0);
                default:
                    return this.state.sort_dir === "desc"
                        ? a.training?.name.localeCompare(b.training?.name)
                        : b.training?.name.localeCompare(a.training?.name);
            }
        });

        return sorted.slice(start, end).map((t) => {
            return (
                <EmployeeTraining
                    key={t.training.id}
                    t={t}
                    isMechanical={this.props.isMechanical}
                />
            );
        });
    };

    render() {
        let start = this.settings.itemsPerPage * (this.state.activePage - 1);
        let end = start + this.settings.itemsPerPage;

        this.setSortingClassNames();

        return (
            <>
                {this.props.spinner}
                <div>{this.renderHeaderToolbar()}</div>
                <div
                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                    id="calisanYonetimi"
                    style={{ display: "block" }}
                >
                    <table
                        className="table display responsive dataTable no-footer dtr-none collapsed"
                        id="dataTablePersonel"
                    >
                        <thead>
                            <tr>
                                <th
                                    onClick={() => this.reOrder("trTrainingMethod")}
                                    className={`desktop sorting${this.trTrainingMethod}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="Eğitim Metodu">10712</Trans>
                                    </div>
                                </th>
                                <th
                                    onClick={() => this.reOrder("trTraining")}
                                    className={`all sorting${this.trTraining}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="Eğitim">10716</Trans>
                                    </div>
                                </th>
                                <DesktopBreakpoint>
                                    <th
                                        onClick={() => this.reOrder("trIsJoined")}
                                        className={`desktop sorting${this.trIsJoined}`}
                                    >
                                        <div className="tableTitle">
                                            <Trans desc="Katıldı">10715</Trans>
                                        </div>
                                    </th>
                                    <th
                                        onClick={() => this.reOrder("trIsSuccess")}
                                        className={`all sorting${this.trIsSuccess}`}
                                    >
                                        <div className="tableTitle">
                                            <Trans desc="Başarı">10709</Trans>
                                        </div>
                                    </th>
                                    <th
                                        onClick={() => this.reOrder("trDuration")}
                                        className={`desktop sorting${this.trDuration}`}
                                    >
                                        <div className="tableTitle">
                                            <Trans desc="Gün">10714</Trans>
                                        </div>
                                    </th>
                                    <th
                                        onClick={() => this.reOrder("trIsTrainingRegistered")}
                                        className={`desktop sorting${this.trIsTrainingRegistered}`}
                                    >
                                        <div className="tableTitle">
                                            <Trans desc="Eğitime Kayıtlı Mı">10717</Trans>
                                        </div>
                                    </th>
                                    <th
                                        onClick={() => this.reOrder("trTrainingArea")}
                                        className={`desktop sorting${this.trTrainingArea}`}
                                    >
                                        <div className="tableTitle">
                                            <Trans desc="Eğitim alanı">10718</Trans>
                                        </div>
                                    </th>
                                    <th
                                        onClick={() => this.reOrder("trPositionTrainingType")}
                                        className={`desktop sorting${this.trPositionTrainingType}`}
                                    >
                                        <div className="tableTitle">
                                            <Trans desc="Pozisyon eğitim türü">10722</Trans>
                                        </div>
                                    </th>
                                    {
                                        this.props.isMechanical ?
                                            <th
                                                onClick={() => this.reOrder("trTechnicalPositionPromotionTrainingType")}
                                                className={`desktop sorting${this.trTechnicalPositionPromotionTrainingType}`}
                                            >
                                                <div className="tableTitle">
                                                    <Trans desc="Teknik pozisyon yükseltme eğitimleri">10734</Trans>
                                                </div>
                                            </th> : null
                                    }
                                    <th
                                        onClick={() => this.reOrder("trWeight")}
                                        className={`desktop sorting${this.trWeight}`}
                                    >
                                        <div className="tableTitle">
                                            <Trans desc="Ağırlık">10719</Trans>
                                        </div>
                                    </th>
                                    <th
                                        onClick={() => this.reOrder("trFutureWeight")}
                                        className={`desktop sorting${this.trFutureWeight}`}
                                    >
                                        <div className="tableTitle">
                                            <Trans desc="Gelecek Ağırlık">10720</Trans>
                                        </div>
                                    </th>
                                </DesktopBreakpoint>
                            </tr>
                        </thead>
                        <tbody>{this.renderData(start, end)}</tbody>
                    </table>
                </div>
                <div>
                    <hr />
                    {this.renderFooterToolbar()}
                </div>
            </>
        );
    }
}


export default (containsLongRunningProcess(EmployeeTrainings));
